export const Bio = {
  name: "N Krishna Chowdary Pathuri",
  roles: [
    "Pega Developer",
    "UI/UX Designer",
    "Prompt Engineer",
    "Full Stack Developer",
  ],
  description:
    "I'm a versatile tech professional with expertise across Pega, UI/UX design, AI, and full-stack development. I build automated workflows and user-friendly interfaces, integrating AI to create intelligent solutions. Ultimately, my goal is to deliver efficient and innovative applications that drive progress.",
  github: "https://github.com/nkcpathuri",
  resume:
    "https://flowcv.com/resume/skrrv3g9n7",
  linkedin: "https://www.linkedin.com/in/nkcpathuri",
  insta: "https://www.instagram.com/infinitewizcrafts/",
  Telegram: "https://t.me/nkcpathuri",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "Pega",
        image:
          "https://www.varindia.com/storage/news/uploads/2018/02/6278c9279e665.jpg",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "Canva",
        image:
          "https://images-eds-ssl.xboxlive.com/image?url=4rt9.lXDC4H_93laV1_eHHFT949fUipzkiFOBH3fAiZZUCdYojwUyX2aTonS1aIwMrx6NUIsHfUHSLzjGJFxxo4K81Ei7WzcnqEk8W.MgwadpHjl76SlQnWKc4OkaILTy7aDmpraBC2vB.Q_eb6EavJPyLEBEEqc.BSkZzu5Vng-&format=source",
      },
      {
        name: "Framer",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR56Lirdms1eL7chV3EXY-3qi1RVFGsjXELiQ&s",
      },
      {
        name: "Express",
        image:
          "https://521324.fs1.hubspotusercontent-na1.net/hubfs/521324/__hs-marketplace__/Adobe_Express_logo_RGB_1024px-1.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Tenserflow",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/TensorFlow_logo.svg/2560px-TensorFlow_logo.svg.png",
      },
      {
        name: "Postman",
        image:
          "https://seeklogo.com/images/P/postman-api-platform-logo-D6B8AB9B0D-seeklogo.com.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Java",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/181_Java_logo_logos-512.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },

      {
        name: "Spring",
        image:
          "https://img.icons8.com/?size=512&id=90519&format=png",
      },
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Chatgpt",
        image:
          "https://static.vecteezy.com/system/resources/thumbnails/021/495/996/small_2x/chatgpt-openai-logo-icon-free-png.png",
      },
      {
        name: "Deepseek",
        image:
          "https://crystalpng.com/wp-content/uploads/2025/01/deepseek-logo-01.png",
      },
      
    ],
  },

];

export const experiences = [
  {
    id: 0,
    img: "https://rpakl.github.io/rpa.kl/images/logo/raplogo.png",
    role: "Core Member, Website Handler",
    company: "Roboti Process Automation Tech Club, KL University",
    date: "January 2023 - Present",
    desc: "I have trained over 300 students in 15+ sessions on RPA tools and automation, providing hands-on experience and practical insights. My sessions focused on building essential skills, understanding real-world applications, and improving problem-solving abilities with automation.",
    skills: [
      "Automation Anywhere",
      "Blue Prism",
      "UiPath",
    ],
  },
  {
    id: 4,
    img: "https://cse.noticebard.com/wp-content/uploads/sites/23/2023/08/Smart-India-Hackathon-2023.jpg",
    role: "Team Member",
    company: "Smart India Hackathon 2023",
    date: "Oct 2023",
    desc: "Developed a Machine Learning-based Language-to-Text and Text-to-Language Converter as a solution to a real-world challenge. This project leverages natural language processing (NLP) and speech recognition technologies to enable seamless conversion between spoken and written language, enhancing accessibility and communication.",
    skills: [
      "Machine Learning",
      "Natural Language Processing (NLP)",
      "Speech Recognition",
      "Python Programming",
      "AI-Powered Automation",
      "Cloud Integration",
    ],
  },
  {
    id: 1,
    img: "https://courses.swechaap.org/pluginfile.php/1/core_admin/logocompact/300x300/1703414656/Swecha%20Square.png",
    role: "Core Member, 3X Spoc in Bootcamps",
    company: "KL Glug Swecha",
    date: "Aug 2021 - Oct 2023",
    desc: "As a Core Member and 3X SPOC at KLGLUG, I have guided over 40 students in bootcamps on Chatbots and Python, helping them build skills in AI-driven solutions and automation.",
    skills: [
      "Chatbot Development",
      "Python",
    ],
  },
  {
    id: 3,
    img: "https://pbs.twimg.com/profile_images/1293170311752347649/PVo5UDnK_400x400.jpg",
    role: "Public Relations Core Member",
    company: "KL Surabhi",
    date: "2025",
    desc: "As a Core Member of the PR team in KL Surabhi, I play a key role in managing communication, promoting events, and enhancing the organization's public presence. I work on creating engaging content, building relationships, and ensuring effective outreach to maximize participation and impact.",
    skills: [
      "Public Relations",
      "Event Promotion",
      "Team Collaboration",
      "Leadership",
    ],
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfuCXNm5eZd3NkxBhJGFseZoG30fpwzEEvaQ&s",
    role: "Creative Arts Coordinator, Non-Technical Organiser",
    company: "KL #include",
    date: "2021 - 2023",
    desc: "I have honed my leadership, creativity, event management and teamwork skills, ensuring smooth execution and innovative solutions in diverse projects.",
    skills: [
      "Communication",
      "Leadership",
      "Public Speaking",
    ],
  },


];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqSHp7AQMO9lYsiaIHdT3VtaHwftSFJt3Lhpoyx6uADkGfpdEpRS_RW42ieEinEP6g4kc&usqp=CAU",
    school: "KL University (Deemed to be University), Vijayawada",
    date: "Sep 2021 - May 2025",
    grade: "9.22 CGPA",
    desc: "I am pursuing a Bachelor of Technology in Computer Science and Engineering at Koneru Lakshmaiah University, graduating with an Honors degree and a CGPA of 9.33. My academic journey has equipped me with strong technical expertise in programming, software development, and emerging technologies like Pega, AI and automation.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCWdt55DsWyHFpaV6kaFW-6N3Aop0TlCloQA7KI4TTZ94-6XWJA2bFy86UUTA2j6nknE8&usqp=CAU",
    school: "Sri Shirdi Sai Junior College",
    date: "June 2019 - March 2021",
    grade: "848/1000",
    desc: "I completed my Board of Intermediate Education, Andhra Pradesh at Sri Shirdi Sai Junior College, securing 848/1000 marks. During this period, I developed a solid foundation in mathematics, physics, and computer science, which laid the groundwork for my engineering studies.",
    degree: "Board of Intermediate Education, Andhra Pradesh (BIEAP)",
  },
  {
    id: 2,
    img: "/Images/dafne.png",
    school: "Sri Shirdi Sai Dafne Asiatic School",
    date: "June 2018 - March 2019",
    grade: "391/500",
    desc: "I completed my secondary education under the Central Board of Secondary Education (CBSE) at Sri Shirdi Sai Dafne Asiatic School, Rajahmundry, India, from June 2018 to March 2019, achieving 391/500 marks. This phase helped me build strong analytical and problem-solving skills while fostering my interest in technology and innovation.",
    degree: "Central Board of Secondary Education (CBSE)",
  },
];

export const projects = [
  {

    //Pega Projects
    id: 1,
    title: " Medical Store Management System",
    date: "Dec 2024 - Feb 2023",
    description:
      "MediCoPlusApp automates pharmaceutical management by handling company details, inventory, and customer interactions. It streamlines CRUD operations, enabling customer registration, automated invoicing, offers, updates, and purchase tracking. With 40% improved efficiency, it enhances accuracy, customer service, and decision-making through robust reporting.",
    image:
      "https://pharmaceuticalupdates.com/wp-content/uploads/2021/05/pharmacy5.jpg",
    tags: [
      "Integration",
      "Access Controls (RBAC, ABAC, Attachment Categories)",
      "Data Pages",
      "Report Definition",
      "Data Transform",
      "Declare Expressions",

    ],
    category: "Pega",
    github: "",
  },
  {
    id: 4,
    title: "Emergency Help Services",
    date: "June 2024 - July 2024",
    description:
      "Developed and implemented an Emergency Help Services system using Pega, designed to streamline emergency response operations and improve service delivery. Users can utilize the two types of Emergency services, Provided by the Service Providers.Medical Services,Fire Services. Technologies Used Pega Platform. Reduced emergency response time by 35% using optimized Pega processes.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8IumCMhIb8FETw4BCTgN_TSkV6xs8JdFIxA&s",
    tags: [
      "Data Pages",
      "Report Definition",
      "Data Transform",
      "Declare Expressions",

    ],
    category: "Pega",
    github: "https://github.com/nkcpathuri/EmergencyHelpServices-Pega",
  },
  {
    id: 7,
    title: "Online Passport Application",
    date: "June 2024 - July 2024",
    description:
      "The application is designed for online passport applications,offering options such as new application and renewal. Depending on the type of application, specific processes and stages are triggered. Various security measures are implemented to protect sensitive data throughout the process. Once all security checks are successfully completed, the passport for the respective applicant is delivered. Digitized passport application, reducing processing time by 50%",
    image:
      "https://wpblogassets.paytm.com/paytmblog/uploads/2024/01/Blog_Paytm_Passport-Renewal-800x500.jpeg",
    tags: [
      "Integration",
      "Access Controls (RBAC, ABAC, Attachment Categories)",
      "Data Pages",
      "Report Definition",
      "Data Transform",
      "Declare Expressions",

    ],
    category: "Pega",
    github: "",
  },
  {
    id: 6,
    title: " Patient Onboarding and Registration",
    date: "Aug 2024 - Sept 2024",
    description:
      "Developed and implemented Patient Onboarding and Registration to capture personal details, medical history, and insurance information. Patients receive medication based on their health condition, and after treatment, the hospital determines the final payment based on their insurance plan.",
    image:
      "https://www.jotform.com/blog/wp-content/uploads/2024/03/How-to-improve-your-patient-onboarding-process-banner-1279x500.jpg",
    tags: [
      "Data Pages",
      "Report Definition",
      "Data Transform",
      "Declare Expressions",

    ],
    category: "Pega",
    github: "https://github.com/nkcpathuri/PatientOnboard-Pega",
  },

  
  //AI & Machine Learning Projects
  {
    id: 2,
    title: "License Plate Detection using YOLO v8",
    date: "Jan 2023 - Mar 2023",
    description:
      "The License Plate Detection Project uses YOLOv8 with TensorFlow to detect vehicle license plates in real-time. It employs deep learning concepts like Convolutional Neural Networks (CNNs) for feature extraction and the TensorFlow Keras for building the model. The project utilizes Binary Crossentropy as a loss function and Adam as an optimizer for efficient training. Techniques like backpropagation, ReLU activation, and Dropout regularization enhance model performance and prevent overfitting. Data augmentation and transfer learning improve accuracy, making the model suitable for traffic control, automated tolls, and vehicle tracking. The implementation of YOLOv8 with TensorFlow for license plate detection improved accuracy by approximately 45%, enhancing the model's effectiveness in real-time vehicle identification and tracking.",
    image:
      "/Images/yolov8.jpg",
    tags: ["Computer Vision", "Deep Learning", "YOLOv8", "TensorFlow & Keras", "Convolutional Neural Networks (CNNs)"],
    category: "machine learning",
    github: "https://github.com/nkcpathuri/LicensePlateDetection-YOLOv8",
  },

  {
    id: 9,
    title: "Stress Detection Using Decision Tree and Naive Bayes Algorithm",
    date: "Jan 2023 - Mar 2023",
    description:
      "The Stress Detection Project aims to develop a machine learning model that detects stress levels in individuals using physiological and behavioral data. It utilizes Decision Tree and Naive Bayes algorithms for classification. Key machine learning topics include supervised learning, feature selection, data preprocessing, model evaluation, cross-validation, and hyperparameter tuning. This project is valuable for enhancing mental health management in healthcare and workplace settings. The implementation of Decision Tree and Naive Bayes algorithms improved stress detection accuracy by approximately 30%, enhancing the model's reliability in identifying stress patterns. ",
    image:
      "/Images/stress.jpg",
    tags: ["Python", "Machine Learning", "Supervised Learning", "Classification Algorithms", "Feature Selection"],
    category: "machine learning",
    github: "https://github.com/nkcpathuri/StressDetection-DecisionTree-NaiveBayes",    
  },

  {
    id: 11,
    title: "Language Convertor along with Speech",
    date: "Jan 2023 - Mar 2023",
    description:
      "The Language Converter with Speech is a machine learning-based system that translates languages while integrating speech recognition and text-to-speech features. It converts spoken input into text, translates it, and vocalizes the output using NLP, Deep Learning, and Transformer models. This project enhances real-time communication and accessibility, making multilingual interactions seamless and efficient.",
    image:
      "/Images/lang.jpg",
    tags: ["Python", "Machine Learning", "Natural Language Processing (NLP) ", "Recurrent Neural Networks (RNNs)", "Speech Processing"],
    category: "machine learning",
    github: "https://github.com/AswithReddyAtla/LangToLangTranslator",    
  },

//Full Stack



  {
    id: 3,
    title: "Employee Leave Management System",
    date: "Dec 2021 - Apr 2022",
    description:
      "The Employee Leave Management System is a full-stack project using Spring Boot and Microservices to manage employee leave requests. It offers secure login, lets employees apply for leaves, and allows managers to approve or reject them. The system tracks leave balances with Spring Data JPA and provides real-time updates.",
    image:
      "/Images/elm.gif",
    tags: ["Spring Boot ", "Microservices", "Spring Data JPA", "RESTful APIs"],
    category: "Full Stack",
    github: "https://github.com/Meghanadh123/Leave-Management-System",
  },
  {
    id:8,
    title: "Automobile Management System",
    date: "Dec 2021 - Apr 2022",
    description:
      "The Automobile Management System is a full-stack web application built using the MERN (MongoDB, Express.js, React.js, Node.js) stack to streamline vehicle management. It enables users to manage vehicle records, track inventory, schedule maintenance, and handle customer interactions. The system supports CRUD operations, user authentication, and real-time updates, ensuring efficient data handling. With an intuitive React.js frontend, a robust Node.js and Express.js backend, and MongoDB for scalable data storage, the application enhances accuracy, efficiency, and decision-making in automobile management.",
    image:
      "/Images/ams.png",
    tags: ["MERN Stack", "React.js", "Node.js", "MySQL"],
    category: "Full Stack",
    github: "https://github.com/nkcpathuri/Automobile-Management-System-",
  },


];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
